var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8983 3.59915C18.5404 3.24462 17.96 3.24462 17.602 3.59915L6.61975 14.4752L2.39836 10.2947C2.0404 9.94012 1.46003 9.94016 1.102 10.2947C0.743996 10.6492 0.743996 11.2239 1.102 11.5784L5.97157 16.4008C6.32943 16.7553 6.91022 16.7551 7.26793 16.4008L18.8983 4.88297C19.2563 4.52847 19.2563 3.95369 18.8983 3.59915Z",
    fill: "#946BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check_mark.d0bf60450a2f359119d9004b852dfd8d.svg";
export { ForwardRef as ReactComponent };